var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{staticClass:"mt-5",attrs:{"elevation":"0"}},[_c('v-card-title',[_vm._v("Questions?")]),_c('v-divider'),_c('v-card-text',[_c('p',[_vm._v("If you have any questions please contact us")]),_c('v-btn',{attrs:{"block":"","text":"","outlined":"","to":{ name: 'contact' }}},[_vm._v("Contact Us")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }